import { CodeBook, PagedResult } from "@king-ict/eupisi-ui/models";
import { axiosBaseQuery } from "@king-ict/eupisi-ui/utils";
import { createApi } from "@reduxjs/toolkit/query/react";

import { CodeBookPagedFilter } from "../models";
import { CommitteeResponse, RegionalCommittee } from "../models/Committee";

export const committeeApi = createApi({
  reducerPath: "committeeApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["InstitutionCountyCommittee", "RegionalCommittee"],
  endpoints: (build) => ({
    getInstitutionCountyCommittee: build.query<CommitteeResponse, number>({
      query: (requestId: number) => ({
        url: `request/get-institution-county-committees/${requestId}`,
      }),
    }),
    getRegionalCommitteeById: build.query<RegionalCommittee, number>({
      query: (id: number) => ({
        url: `regional-committee/get/${id}`,
      }),
    }),
    searchInstitutionCommitteeEmployee: build.query<
      PagedResult<CodeBook>,
      CodeBookPagedFilter
    >({
      query: (search: CodeBookPagedFilter) => ({
        url: "institution-committees/search-employees",
        method: "post",
        data: search,
      }),
    }),
    searchCountyCommitteeEmployee: build.query<
      PagedResult<CodeBook>,
      CodeBookPagedFilter
    >({
      query: (search: CodeBookPagedFilter) => ({
        url: "county-committees/search-employees",
        method: "post",
        data: search,
      }),
    }),
    searchMinistryCommitteeEmployee: build.query<
      PagedResult<CodeBook>,
      CodeBookPagedFilter
    >({
      query: (search: CodeBookPagedFilter) => ({
        url: "ministry-committees/search-employees",
        method: "post",
        data: search,
      }),
    }),
    searchRegionalCommitteeEmployee: build.query<
      PagedResult<CodeBook>,
      CodeBookPagedFilter
    >({
      query: (search: CodeBookPagedFilter) => ({
        url: "regional-committee/search-employees",
        method: "post",
        data: search,
      }),
    }),
    deleteCountyCommittee: build.mutation<void, number>({
      query: (countyCommitteeId: number) => ({
        url: `county-committees/${countyCommitteeId}`,
        method: "delete",
      }),
    }),
    deleteInstitutionCommittee: build.mutation<void, number>({
      query: (institutionCommitteeId: number) => ({
        url: `institution-committees/${institutionCommitteeId}`,
        method: "delete",
      }),
    }),
    deleteRegionalCommittee: build.mutation<void, number>({
      query: (regionalCommitteeId: number) => ({
        url: `regional-committee/${regionalCommitteeId}`,
        method: "delete",
      }),
    }),
    deleteMinistryCommittee: build.mutation<void, number>({
      query: (ministryCommitteeId: number) => ({
        url: `ministry-committees/${ministryCommitteeId}`,
        method: "delete",
      }),
    }),
  }),
});

export const {
  useGetInstitutionCountyCommitteeQuery,
  useGetRegionalCommitteeByIdQuery,
  useDeleteCountyCommitteeMutation,
  useDeleteInstitutionCommitteeMutation,
  useDeleteRegionalCommitteeMutation,
  useDeleteMinistryCommitteeMutation,
  useSearchInstitutionCommitteeEmployeeQuery,
  useLazySearchInstitutionCommitteeEmployeeQuery,
  useSearchCountyCommitteeEmployeeQuery,
  useLazySearchCountyCommitteeEmployeeQuery,
  useSearchMinistryCommitteeEmployeeQuery,
  useLazySearchMinistryCommitteeEmployeeQuery,
  useSearchRegionalCommitteeEmployeeQuery,
  useLazySearchRegionalCommitteeEmployeeQuery,
} = committeeApi;
